// Auto-generated by scripts/generate-registry.mjs from packages/modules/e27_led_base/ui-config.json — DO NOT EDIT MANUALLY!
import type { ModuleSchema } from './types.js';

export const e27_led_base: ModuleSchema = {
  "id": "e27_led_base",
  "uniqueId": "B3D_9JN17",
  "createdAt": "2026-10-02T06:01:29.727Z",
  "updatedAt": "2026-10-30T10:31:13.344Z",
  "label": "E27 Socket Base",
  "description": "Base module clean with bottom screw feet and E27 socket holder",
  "category": "lighting",
  "tags": [
    "e27-led-base"
  ],
  "sliders": [
    {
      "key": "baseDia",
      "label": "Base Diameter",
      "min": 70,
      "max": 180,
      "default": 110,
      "step": 1,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseH",
      "label": "Base Height",
      "min": 30,
      "max": 150,
      "default": 100,
      "step": 1,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseCornerR",
      "label": "Base Fillet",
      "min": 0,
      "max": 10,
      "default": 2,
      "step": 0.5,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseRibCount",
      "label": "Base Outer Ribs (0=Smooth)",
      "min": 0,
      "max": 36,
      "default": 0,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseRibWidth",
      "label": "Base Rib Width",
      "min": 1,
      "max": 8,
      "default": 3,
      "step": 0.5,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseRibDepth",
      "label": "Base Rib Protrusion",
      "min": 0.4,
      "max": 3,
      "default": 1,
      "step": 0.1,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseTextureType",
      "label": "Base Surface Texture (0=Smooth, 1=Fluting, 2=Rattan, 3=Knurl, 4=Wood Grain, 5=Stone/Rock)",
      "min": 0,
      "max": 5,
      "default": 0,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseTextureScale",
      "label": "Texture Density / Scale",
      "min": 4,
      "max": 24,
      "default": 8,
      "step": 1,
      "unit": "",
      "integerOnly": true,
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "baseTextureDepth",
      "label": "Texture Relief Depth",
      "min": 0.2,
      "max": 1.5,
      "default": 0.5,
      "step": 0.1,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "screwPcd",
      "label": "Screw Circle PCD",
      "min": 40,
      "max": 130,
      "default": 85,
      "step": 1,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "shadeH",
      "label": "Shade Height",
      "min": 100,
      "max": 400,
      "default": 170,
      "step": 10,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "shadeWall",
      "label": "Shade Wall Thickness",
      "min": 1,
      "max": 5,
      "default": 2,
      "step": 0.5,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    },
    {
      "key": "patternType",
      "label": "Pattern Hole Shape",
      "min": 0,
      "max": 2,
      "default": 0,
      "step": 1,
      "unit": "",
      "category": "patterns",
      "enabled": true,
      "visible": true
    },
    {
      "key": "patternSize",
      "label": "Pattern Hole Size",
      "min": 3,
      "max": 20,
      "default": 8,
      "step": 1,
      "unit": "mm",
      "category": "patterns",
      "enabled": true,
      "visible": true
    },
    {
      "key": "patternRows",
      "label": "Pattern Rows",
      "min": 4,
      "max": 30,
      "default": 16,
      "step": 1,
      "unit": "",
      "category": "patterns",
      "enabled": true,
      "visible": true
    },
    {
      "key": "patternCols",
      "label": "Pattern Columns",
      "min": 4,
      "max": 24,
      "default": 12,
      "step": 1,
      "unit": "",
      "category": "patterns",
      "enabled": true,
      "visible": true
    },
    {
      "key": "e27HoleDia",
      "label": "E27 Socket Center Hole Dia",
      "min": 25,
      "max": 60,
      "default": 41.5,
      "step": 0.5,
      "unit": "mm",
      "category": "dimensions",
      "enabled": true,
      "visible": true
    }
  ],
  "selects": [],
  "textParams": [],
  "colorConfigs": [
    {
      "key": "shade_body",
      "label": "Lampshade Body",
      "default": "#F3F4F6",
      "targetGroupIds": [
        0
      ]
    },
    {
      "key": "base_body",
      "label": "Base Body",
      "default": "#7C2D12",
      "targetGroupIds": [
        1
      ]
    },
    {
      "key": "screw_feet",
      "label": "4x Male Feet Screws",
      "default": "#9CA3AF",
      "targetGroupIds": [
        2
      ]
    }
  ],
  "objects": [
    {
      "id": "shade_obj",
      "label": "Cylindrical Patterned Lampshade (170mm)",
      "name": "Cylindrical Patterned Lampshade (170mm)",
      "color": "#F3F4F6",
      "assembled_z_offset": 0,
      "exploded_z_offset": 100,
      "parts": [
        {
          "id": "shade_body",
          "label": "Lampshade Body",
          "name": "Lampshade Body",
          "groupId": 0,
          "colorKey": "shade_body",
          "defaultColor": "#F3F4F6",
          "assembled_z_offset": 0,
          "exploded_z_offset": 100,
          "export_stl": true
        }
      ]
    },
    {
      "id": "base_obj",
      "label": "Base Solid + 4 Female Screw Holes",
      "name": "Base Solid + 4 Female Screw Holes",
      "color": "#7C2D12",
      "assembled_z_offset": 0,
      "exploded_z_offset": 0,
      "parts": [
        {
          "id": "base_body",
          "label": "Base Body",
          "name": "Base Body",
          "groupId": 1,
          "colorKey": "base_body",
          "defaultColor": "#7C2D12",
          "assembled_z_offset": 0,
          "exploded_z_offset": 0,
          "export_stl": true
        }
      ]
    },
    {
      "id": "screw_obj",
      "label": "4x Male Screws / Feet",
      "name": "4x Male Screws / Feet",
      "color": "#9CA3AF",
      "assembled_z_offset": 0,
      "exploded_z_offset": -30,
      "parts": [
        {
          "id": "screw_feet",
          "label": "4x Male Feet Screws",
          "name": "4x Male Feet Screws",
          "groupId": 2,
          "colorKey": "screw_feet",
          "defaultColor": "#9CA3AF",
          "assembled_z_offset": 0,
          "exploded_z_offset": -30,
          "export_stl": true
        }
      ]
    }
  ],
  "exportGroups": [
    {
      "id": "all",
      "label": "Download STL - Full Lamp Assembly"
    },
    {
      "id": "shade",
      "label": "Download STL - Lampshade Only"
    },
    {
      "id": "base",
      "label": "Download STL - Base Only"
    },
    {
      "id": "screws",
      "label": "Download STL - 4x Screws Only"
    },
    {
      "id": "cap",
      "label": "Download STL - LED Cap Only"
    }
  ]
};
